import Nullstack from 'nullstack';
export default function IconCaptureOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-capture-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), "   ", Nullstack.element("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), "   ", Nullstack.element("path", {
    d: "M16 20h2c.554 0 1.055 -.225 1.417 -.589"
  }), "   ", Nullstack.element("path", {
    d: "M9.87 9.887a3 3 0 0 0 4.255 4.23m.58 -3.416a3.012 3.012 0 0 0 -1.4 -1.403"
  }), "   ", Nullstack.element("path", {
    d: "M4 8v-2c0 -.548 .22 -1.044 .577 -1.405"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}